import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Card, Col, Form, Input, Layout, Modal, Row, Space } from 'antd';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import calls from '../api/calls';

export const LoginPage = () => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState<{ email: string; password: string }>({ email: '', password: '' });
  const [forgotPasswordLoading, setForgotPasswordLoading] = useState(false);
  const [forgotPasswordVisible, setForgotPasswordVisible] = useState(false);

  const forgotPasswordCancelHandler = () => setForgotPasswordVisible(false);

  const formChangeHandler = (changedValues) => setValues({ ...values, ...changedValues });

  const formHandler = async () => {
    setLoading(true);
    try {
      await calls.auth.login(values.email, values.password);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const passwordForgotFormHandler = async () => {
    setForgotPasswordLoading(true);
    setForgotPasswordVisible(false);
    await calls.auth.forgotPassword(values.email);
    setForgotPasswordLoading(false);
  };

  const forgotEmailLink = useMemo(() => {
    return `mailto:cls@procuragroup.dk?subject=${t('forgotEmailSubject')}&body=${t('forgotEmailBody')}`;
  }, [t]);

  const forgotEmailModal = () =>
    Modal.confirm({
      title: t('forgotEmail'),
      content: (
        <Space direction="vertical" size="small">
          <div>{t('forgotEmailDescription')}</div>
          <a href={forgotEmailLink}>cls@procuragroup.dk</a>
        </Space>
      ),
    });

  return (
    <Layout>
      <Layout.Content>
        <Row justify={'center'} align={'middle'} className="pg-u-full-view-height">
          <Col className="pg-login-page-container">
            <Card title={t('loginTitle')} bordered={true}>
              <Form onFinish={formHandler} onValuesChange={formChangeHandler}>
                <Form.Item name="email" rules={[{ required: true, message: t('emailInvalid'), type: 'email' }]}>
                  <Input
                    value={values.email}
                    type="email"
                    placeholder={t('email')}
                    prefix={<UserOutlined />}
                    readOnly={loading}
                  />
                </Form.Item>
                <Form.Item name="password" rules={[{ required: true, message: t('passwordInvalid') }]}>
                  <Input
                    value={values.password}
                    type="password"
                    placeholder={t('password')}
                    prefix={<LockOutlined />}
                    readOnly={loading}
                  />
                </Form.Item>
                <Space direction="vertical" size="small" className="pg-u-full-width">
                  <Button type="primary" htmlType="submit" loading={loading} className="pg-u-full-width">
                    {t('login')}
                  </Button>
                  <Button disabled={loading} className="pg-u-full-width" href="https://www.procuragroup.dk/">
                    {t('cancel')}
                  </Button>
                  <div>
                    <Button
                      type="link"
                      disabled={loading}
                      className="pg-u-full-width"
                      onClick={() => setForgotPasswordVisible(true)}>
                      {t('forgotPassword')}
                    </Button>
                    <Button type="link" disabled={loading} className="pg-u-full-width" onClick={forgotEmailModal}>
                      {t('forgotEmail')}
                    </Button>
                  </div>
                </Space>
              </Form>
            </Card>
          </Col>
        </Row>
        <Modal
          title={t('forgotPassword')}
          visible={forgotPasswordVisible}
          confirmLoading={forgotPasswordLoading}
          onCancel={forgotPasswordCancelHandler}
          okText={t('send')}
          onOk={passwordForgotFormHandler}>
          <Form onFinish={passwordForgotFormHandler} onValuesChange={formChangeHandler}>
            <Form.Item
              name="email"
              rules={[{ required: true, message: t('emailInvalid'), type: 'email' }]}
              extra={t('forgotPasswordDescription')}>
              <Input
                value={values.email}
                type="email"
                placeholder={t('email')}
                prefix={<UserOutlined />}
                readOnly={loading}
              />
            </Form.Item>
          </Form>
        </Modal>
      </Layout.Content>
    </Layout>
  );
};
